import {findMetadata, isDateAfter} from '../../../util/helpers';
import {Communication, DefaultDeliveryFlow} from '../../../util/types';
import {StatusIndicatorGood} from './StatusIndicatorGood';
import {StatusIndicatorWithNotifications} from './StatusIndicatorWithNotifications';

export default function StatusIndicator({deliveryFlow, requests}: {
    deliveryFlow: DefaultDeliveryFlow,
    requests: Communication[],
}) {
    /**
     * __4 statusser:__
     * 1. Ingen ulæste beskeder og ingen afvisningskode/ombooking initeret af netejer
     * 2. Ulæste beskeder, og ingen afvisningskode/ombooking initeret af netejer
     * 3. Ingen ulæste beskeder og der er afvisningskode/ombooking initieret af netejer
     * 4. Ulæste beskeder, og der er afvisningskode/ombooking initieret af netejer
     */
    const has_ever_been_rescheduled = findMetadata('has_ever_been_rescheduled', deliveryFlow.timeline_metadata);
    const has_ever_been_rejected = findMetadata('has_ever_been_rejected', deliveryFlow.timeline_metadata);
    const has_ever_had_digging_code_discrepancy = findMetadata('has_ever_had_digging_code_discrepancy', deliveryFlow.timeline_metadata);

    const active_date = findMetadata('product_instance_status_active_date', deliveryFlow.timeline_metadata);
    const is_online: boolean = !active_date ? false : isDateAfter(active_date);

    const unread = requests.filter((request) => request.read_dtm === null);
    const unread_count = unread.length;
    const has_unread_notifications = unread_count > 0;

    const good = !has_ever_been_rejected &&
        !has_ever_been_rescheduled &&
        !has_ever_had_digging_code_discrepancy

    const bad = has_ever_been_rejected ||
        has_ever_been_rescheduled ||
        has_ever_had_digging_code_discrepancy

    const scenario_1 = good && !has_unread_notifications;
    const scenario_2 = good && has_unread_notifications;
    const scenario_3 = bad && !has_unread_notifications;
    const scenario_4 = bad && has_unread_notifications;

    if (is_online) {
        return null;
    }

    if (scenario_1) {
        return <StatusIndicatorGood/>;
    }
    if (scenario_2) {
        return <StatusIndicatorWithNotifications
            unread={unread}
            alert={false}
        />;
    }
    if (scenario_3) {
        return null;
    }
    if (scenario_4) {
        return <StatusIndicatorWithNotifications
            unread={unread}
            alert={true}
        />;
    }

    return null;
}
